import React from 'react';
import TemplateRenderer from './components/TemplateRenderer';

function App() {
  return (
    <div>
      <TemplateRenderer />
    </div>
  );
}

export default App;
